import { render, staticRenderFns } from "./CostSubmenu.vue?vue&type=template&id=7120078e&"
import script from "./CostSubmenu.vue?vue&type=script&lang=js&"
export * from "./CostSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports